import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import Header from './Components/header'
import routes from './Routes/routes'

const history = createBrowserHistory()

const ConfigurableRoute = (route) => (
  <Route path={route.path} component={route.component} {...route}
    />
)

class App extends React.Component {
  render() {
    return (
        <Router history={history}>
          <div>
            <Header name="Fieldnotes" slogan="Create and view notes" />
            <Switch>
            {routes.map((route, i) => (
               <ConfigurableRoute key={i} {...route} />
             ))}
             </Switch>
          </div>
        </Router>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js